// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelectClientsStepDataQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type SelectClientsStepDataQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, integrationClients?: Array<{ __typename?: 'IntegrationClient', id: string, name: string, kind: Types.IntegrationClientKind }> | null } | null } | null> | null } };

export type UpdateHouseholdIntegrationClientsMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  input: Types.UpdateHouseholdInput;
}>;


export type UpdateHouseholdIntegrationClientsMutation = { __typename?: 'Mutation', updateHousehold: { __typename?: 'Household', id: string, integrationClients?: Array<{ __typename?: 'IntegrationClient', id: string, name: string, kind: Types.IntegrationClientKind }> | null } };

export const Operations = {
  Query: {
    SelectClientsStepData: 'SelectClientsStepData' as const
  },
  Mutation: {
    UpdateHouseholdIntegrationClients: 'UpdateHouseholdIntegrationClients' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SelectClientsStepDataDocument = gql`
    query SelectClientsStepData($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        integrationClients {
          id
          name
          kind
        }
      }
    }
  }
}
    `;

/**
 * __useSelectClientsStepDataQuery__
 *
 * To run a query within a React component, call `useSelectClientsStepDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectClientsStepDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectClientsStepDataQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useSelectClientsStepDataQuery(baseOptions: Apollo.QueryHookOptions<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>(SelectClientsStepDataDocument, withFetchPolicyContext(options));
      }
export function useSelectClientsStepDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>(SelectClientsStepDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSelectClientsStepDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>(SelectClientsStepDataDocument, withFetchPolicyContext(options));
        }
export type SelectClientsStepDataQueryHookResult = ReturnType<typeof useSelectClientsStepDataQuery>;
export type SelectClientsStepDataLazyQueryHookResult = ReturnType<typeof useSelectClientsStepDataLazyQuery>;
export type SelectClientsStepDataSuspenseQueryHookResult = ReturnType<typeof useSelectClientsStepDataSuspenseQuery>;
export type SelectClientsStepDataQueryResult = Apollo.QueryResult<SelectClientsStepDataQuery, SelectClientsStepDataQueryVariables>;
export const UpdateHouseholdIntegrationClientsDocument = gql`
    mutation UpdateHouseholdIntegrationClients($householdId: ID!, $input: UpdateHouseholdInput!) {
  updateHousehold(id: $householdId, input: $input) {
    id
    integrationClients {
      id
      name
      kind
    }
  }
}
    `;
export type UpdateHouseholdIntegrationClientsMutationFn = Apollo.MutationFunction<UpdateHouseholdIntegrationClientsMutation, UpdateHouseholdIntegrationClientsMutationVariables>;

/**
 * __useUpdateHouseholdIntegrationClientsMutation__
 *
 * To run a mutation, you first call `useUpdateHouseholdIntegrationClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHouseholdIntegrationClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHouseholdIntegrationClientsMutation, { data, loading, error }] = useUpdateHouseholdIntegrationClientsMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHouseholdIntegrationClientsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHouseholdIntegrationClientsMutation, UpdateHouseholdIntegrationClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHouseholdIntegrationClientsMutation, UpdateHouseholdIntegrationClientsMutationVariables>(UpdateHouseholdIntegrationClientsDocument, options);
      }
export type UpdateHouseholdIntegrationClientsMutationHookResult = ReturnType<typeof useUpdateHouseholdIntegrationClientsMutation>;
export type UpdateHouseholdIntegrationClientsMutationResult = Apollo.MutationResult<UpdateHouseholdIntegrationClientsMutation>;
export type UpdateHouseholdIntegrationClientsMutationOptions = Apollo.BaseMutationOptions<UpdateHouseholdIntegrationClientsMutation, UpdateHouseholdIntegrationClientsMutationVariables>;